import React from 'react';
type Variant = 'primary' | 'whatsapp' | 'outline' | 'outlineLight' | 'secondary';
type Size = 'md' | 'lg' | 'sm';
const base = 'inline-flex items-center justify-center gap-2 font-sans font-bold rounded-lg transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
const variants: Record<Variant, string> = {
  primary: 'bg-primary text-white hover:bg-[#16304c] active:bg-[#122741] shadow-soft',
  whatsapp: 'bg-whatsapp text-white shadow-wa hover:bg-[#1f8b53] hover:shadow-wa-lg active:bg-[#1a7647]',
  outline: 'border-[1.5px] border-primary text-primary bg-transparent hover:bg-primary/5 active:bg-primary/10',
  outlineLight: 'border-[1.5px] border-white/40 text-white bg-transparent hover:bg-white/10 active:bg-white/15',
  secondary: 'bg-secondary text-white hover:bg-[#2f9a95] active:bg-[#2a8a86] shadow-soft'
};
const sizes: Record<Size, string> = {
  sm: 'px-[18px] py-[10px] text-[13px] font-semibold',
  md: 'px-6 py-[14px] text-[15px]',
  lg: 'px-8 py-4 text-[17px] rounded-[10px]'
};
type ButtonProps = {
  variant?: Variant;
  size?: Size;
  className?: string;
  children: React.ReactNode;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>;
export function LinkButton({
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  ...rest
}: ButtonProps) {
  return <a className={`${base} ${variants[variant]} ${sizes[size]} ${className}`} {...rest} data-id="element-330" data-mp="12mjx5qwtimzz">
      {children}
    </a>;
}
type NativeButtonProps = {
  variant?: Variant;
  size?: Size;
  className?: string;
  children: React.ReactNode;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;
export function Button({
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  ...rest
}: NativeButtonProps) {
  return <button type="button" className={`${base} ${variants[variant]} ${sizes[size]} ${className}`} {...rest} data-id="element-331" data-mp="1lewa17l3l6od">
      {children}
    </button>;
}